import React from 'react';
import {render} from 'react-dom';
import {createHashHistory} from 'history';
import {routerMiddleware} from 'connected-react-router'
import configureStore from './store/configureStore';
import Root from './containers/Root'
import 'bootstrap/dist/css/bootstrap.css';
import 'react-bootstrap-table/css/react-bootstrap-table.css'
import 'react-select/dist/react-select.esm';
import 'pikaday/css/pikaday.css'
import './resources/css/style.css';
import './resources/css/font-awesome.min.css';


const hashHistory = createHashHistory();
const router = routerMiddleware(hashHistory);

const store = configureStore(router, hashHistory);

render(
	<Root store={store} history={hashHistory}/>,
	document.getElementById('root')
);
